import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Menu from './menu/menu.container';
import {
  Header,
  Nav,
  MenuContainer,
  HiddenOnScrollContainer,
  StickyContainer,
  SkipNavButton,
  HeightModulatedContainer,
} from './navigation.styles';
import { HeaderLogo } from './headerLogo';
import { WindowListener } from '../../components/windowListener/windowListener.component';
import { HeaderStyle } from '../../reducers/menu/menu.redux';
import { identifiers, isBelowBurgerResolution } from '../../utils/rendering';
import { CategoryNavigation } from '../../components/categoryNavigation';
import { isMobile, isLandscape, isTabletPortrait } from '../../theme/media';
const HIDE_THRESHOLD = 184;

export class Navigation extends PureComponent {
  static propTypes = {
    contentType: PropTypes.string.isRequired,
    entryId: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    headerStyle: PropTypes.string,
    isOpened: PropTypes.bool,
    isCategoryMenuVisible: PropTypes.bool,
    isCurtained: PropTypes.bool.isRequired,
    setMenuOpened: PropTypes.func,
    logo: PropTypes.object,
    logoMobile: PropTypes.object,
    location: PropTypes.object,
    isManuallyFixed: PropTypes.bool,
  };

  state = {
    scrolledTop: true,
    isScrollingDown: false,
    showsBurgerMenu: isBelowBurgerResolution(),
    isSmallDevice: isMobile(),
  };

  lastScroll = 0;

  handleScroll = () => {
    const { isCurtained, isManuallyFixed } = this.props;
    const currentScroll = window.scrollY;

    this.setState({
      scrolledTop: currentScroll <= 1 || isManuallyFixed,
      isScrollingDown:
        currentScroll > this.lastScroll &&
        currentScroll > (isCurtained ? HIDE_THRESHOLD + 1000 : HIDE_THRESHOLD) &&
        !isManuallyFixed,
    });

    this.lastScroll = currentScroll;
  };

  handleWindowResize = () => {
    const showsBurgerMenu = isBelowBurgerResolution();
    const isSmallDevice = isMobile();
    if (showsBurgerMenu !== this.state.showsBurgerMenu) {
      this.setState({ showsBurgerMenu });
    }

    if (isSmallDevice !== this.state.isSmallDevice) {
      this.setState({ isSmallDevice });
    }

    if (!showsBurgerMenu) {
      this.props.setMenuOpened(false);
    }
  };

  render() {
    const { contentType, entryId, isOpened, isCategoryMenuVisible, headerStyle, logo, logoMobile } =
      this.props;
    const { showsBurgerMenu, isSmallDevice, isScrollingDown, scrolledTop } = this.state;

    const preventHide =
      isCategoryMenuVisible && (isTabletPortrait() || isMobile()) && isLandscape();

    const hiddenByScroll =
      !this.props.isManuallyFixed &&
      !preventHide &&
      headerStyle !== HeaderStyle.MINIMAL &&
      isScrollingDown &&
      !isOpened;

    return (
      <Header {...identifiers('Navigation', contentType, entryId)} role="banner">
        <StickyContainer
          shouldStick={headerStyle !== HeaderStyle.MINIMAL && !preventHide}
          hiddenByScroll={hiddenByScroll}
        >
          <HeightModulatedContainer
            shouldOverlap={headerStyle === HeaderStyle.ABSOLUTE}
            hiddenByScroll={hiddenByScroll}
          >
            <HiddenOnScrollContainer
              hiddenByScroll={hiddenByScroll}
              headerStyle={headerStyle}
              preventHide={preventHide}
              isCategoryMenuVisible={isCategoryMenuVisible}
            >
              <Nav
                role="navigation"
                scrolledTop={scrolledTop}
                headerStyle={headerStyle}
                isOpened={isOpened}
                showsBurgerMenu={showsBurgerMenu}
                data-offset-sidemenu={true}
              >
                <WindowListener
                  handledFunction={this.handleScroll}
                  throttleValue={100}
                  eventType="scroll"
                />
                <WindowListener
                  handledFunction={this.handleWindowResize}
                  throttleValue={250}
                  eventType="resize"
                />
                <SkipNavButton />
                <HeaderLogo logo={logo} logoMobile={logoMobile} />
                <MenuContainer row>
                  {headerStyle !== HeaderStyle.MINIMAL && (
                    <Menu isSmallDevice={isSmallDevice} showsBurgerMenu={showsBurgerMenu} />
                  )}
                </MenuContainer>
              </Nav>
            </HiddenOnScrollContainer>
            {isCategoryMenuVisible && (
              <CategoryNavigation
                hiddenByScroll={!preventHide && isScrollingDown}
                location={this.props.location}
              />
            )}
          </HeightModulatedContainer>
        </StickyContainer>
      </Header>
    );
  }
}
